module.exports = __webpack_public_path__ + "ipetbooking/admin/img/credit-card.1e2bb55d.svg";